var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.shown)?_c('div',{staticClass:"ViewerNotice",class:{ hide: !_vm.shown, show: _vm.shown }},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }